module.exports = __webpack_public_path__ + "static/media/veri.adc8c90b.svg";